function ChatEventViewModel(eventData, userParticipantId) {
    let self = this;

    self.displayName = eventData.participantId === userParticipantId ? "You" : eventData.displayName;
    self.message = eventData.message || eventData.value || "";
}

module.exports = ChatEventViewModel;